import { Cookie } from '@vue-util/cookie';
import isBcom from './isBcom';

export const setUserIdCookies = ({ id, guid }) => {
  if (typeof window !== 'undefined') {
    if (id && id !== Cookie.get(isBcom ? 'bloomingdales_online_uid' : 'macys_online_uid')) {
      Cookie.set(isBcom ? 'bloomingdales_online_uid' : 'macys_online_uid', id);
    }

    if (guid && guid !== Cookie.get(isBcom ? 'bloomingdales_online_guid' : 'macys_online_guid')) {
      Cookie.set(isBcom ? 'bloomingdales_online_guid' : 'macys_online_guid', guid);
    }
  }
};

export const getUserGuid = () => {
  let userGuid = null;

  if (typeof window !== 'undefined') {
    userGuid = Cookie.get(isBcom ? 'bloomingdales_online_guid' : 'macys_online_guid');
  }

  return userGuid;
};
